@if(showLqImage() || loaded()) {
<img
  [src]="currentSrc()"
  (load)="onLoad()"
  [loading]="loading()"
  [attr.fetchpriority]="fetchPriority()"
  class="{{ class() }}"
  [ngClass]="{ loaded: loaded }"
  alt="gallery"
/>
} @else {
<div class="{{ class() }}"></div>
}
